import type { UsernameAvailable } from '../useIsUsernameAvailable'
import type { Texts } from '../useTexts'

export const createValidateUsername = async (
  texts: Texts,
  username: string,
  isUsernameAvailable: UsernameAvailable,
  initialValue: string,
) => {
  const fieldChanged = username !== initialValue

  const usernameMinLength = 6
  const usernameMaxLength = 50

  const usernameRequiredError = {
    id: 'usernameRequiredError',
    message: texts.errors.required('username'),
    field: 'username' as const,
    priority: 10,
  }

  const usernameUniqueError = {
    id: 'usernameUniqueError',
    message: texts.errors.unique,
    field: 'username' as const,
    priority: 15,
  }

  const usernameMinLengthError = {
    id: 'usernameMinLengthError',
    message: texts.errors.minLength(usernameMinLength),
    field: 'username' as const,
    priority: 15,
  }

  const usernameMaxLengthError = {
    id: 'usernameMaxLengthError',
    message: texts.errors.maxLength(usernameMaxLength),
    field: 'username' as const,
    priority: 15,
  }

  const requiredError = username.length === 0
  const minLengthError = username.length < usernameMinLength
  const maxLengthError = username.length > usernameMaxLength

  const canCallIsUsernameAvailable =
    !requiredError && !minLengthError && !maxLengthError && fieldChanged

  // username available status is only relevant if no other errors are present
  const [usernameStatus] = canCallIsUsernameAvailable
    ? await isUsernameAvailable(username)
    : ['available']

  return {
    [usernameRequiredError.id]: requiredError ? usernameRequiredError : undefined,
    [usernameMinLengthError.id]: minLengthError ? usernameMinLengthError : undefined,
    [usernameMaxLengthError.id]: maxLengthError ? usernameMaxLengthError : undefined,
    [usernameUniqueError.id]: usernameStatus !== 'available' ? usernameUniqueError : undefined,
  }
}
